/**
 * Split a full name string into first and last name parts.
 * Handles null/undefined/empty values gracefully.
 *
 * Examples:
 *   "Jane Doe"        → { firstName: "Jane", lastName: "Doe" }
 *   "Mary Ann Smith"  → { firstName: "Mary", lastName: "Ann Smith" }
 *   "Cher"            → { firstName: "Cher", lastName: "" }
 *   null / ""         → { firstName: "", lastName: "" }
 */
export function splitFullName(full?: string | null): { firstName: string; lastName: string } {
  const parts = (full ?? '').trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return { firstName: '', lastName: '' };
  const [firstName, ...rest] = parts;
  return { firstName, lastName: rest.join(' ') };
}

/** Returns "First Last" for a person object, or null when the person is null/undefined. */
export function fullName(
  person: { firstName: string; lastName: string } | null | undefined,
): string | null {
  return person ? `${person.firstName} ${person.lastName}` : null;
}
